'use client';

import { useBuilding } from '@/app/building/context/BuildingProvider';
import type { Building } from '@repo/api';
import { cn } from '@/lib/cn';
import ReportDetailContent from './ReportDetailContent';

interface BuildingTabContentProps {
  building: Building;
  params: {
    city: string;
    buildingId: string;
    slug: string;
  };
}

/**
 * Client wrapper component that conditionally hides BuildingDetailContent when report tab is active.
 */
export function BuildingTabWrapper({ children }: { children: React.ReactNode }) {
  const { activeTab } = useBuilding();

  return <div className={cn(activeTab === 'report' && 'hidden')}>{children}</div>;
}

/**
 * Client component that handles tab switching.
 * BuildingDetailContent is always rendered on the server (in page.tsx).
 * This component only renders ReportDetailContent when report tab is active.
 */
export function BuildingTabContent({ building, params }: BuildingTabContentProps) {
  const { activeTab } = useBuilding();

  // Only render report content when report tab is active
  return (
    <div className={cn(activeTab !== 'report' && 'hidden')}>
      <ReportDetailContent building={building} params={params} isActive={activeTab === 'report'} />
    </div>
  );

  // When overview is active, this component renders nothing
  // The server-rendered BuildingDetailContent in page.tsx will be visible
  return null;
}
